import { FC, useEffect, useRef, useState } from "react";
import {
  BrowserMultiFormatReader,
  NotFoundException,
  BarcodeFormat,
  DecodeHintType,
} from "@zxing/library";

import "./QrStyles.css";

const QrReader: FC<{
  setScannedResult: (value: string) => void;
}> = ({ setScannedResult }) => {
  const videoEl = useRef<HTMLVideoElement>(null);
  const qrBoxEl = useRef<HTMLDivElement>(null);
  const [qrOn, setQrOn] = useState<boolean>(true);

  const codeReader = useRef<BrowserMultiFormatReader | null>(null);

  useEffect(() => {
    if (!codeReader.current) {
      const hints = new Map();
      const formats = [
        BarcodeFormat.QR_CODE, // lendo QR Code
        BarcodeFormat.CODE_128, // Formato SKU de 10 dígitos
        BarcodeFormat.EAN_13, // Formato padrão de mercado
        BarcodeFormat.EAN_8,
        BarcodeFormat.CODE_39,
      ];

      hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
      hints.set(DecodeHintType.TRY_HARDER, true);

      codeReader.current = new BrowserMultiFormatReader(hints);
    }

    const startScanning = async () => {
      if (videoEl.current && codeReader.current) {
        try {
          await codeReader.current.decodeFromConstraints(
            {
              audio: false,
              video: {
                facingMode: "environment",
                width: { min: 640, ideal: 1280 },
                height: { min: 480, ideal: 720 },
              },
            },
            videoEl.current,
            (result, error) => {
              if (result) {
                console.log("Código lido:", result.getText());
                setScannedResult(result.getText());
              }
              if (error && !(error instanceof NotFoundException)) {
                console.error(error);
              }
            },
          );
          setQrOn(true);
        } catch (err) {
          console.error("Erro ao iniciar a câmera", err);
          setQrOn(false);
        }
      }
    };

    startScanning();

    return () => {
      if (codeReader.current) {
        codeReader.current.reset();
      }
    };
  }, [setScannedResult]);

  useEffect(() => {
    if (!qrOn) {
      alert(
        "Câmera bloqueada ou inacessível. Por favor, autorize e recarregue.",
      );
    }
  }, [qrOn]);

  return (
    <div className="qr-reader">
      <video
        ref={videoEl}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      ></video>
      <div ref={qrBoxEl} className="qr-box"></div>
    </div>
  );
};

export { QrReader };
